
<custom-host-name-url-setup
  :env-urls="envUrls"
  :loading="loading"
  @continueToConfigDns="continueToConfigDns()"
  @skipHostNameUrlSetup="skipHostNameUrlSetup()"
>
</custom-host-name-url-setup>
